<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Voucher Usage Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                v-model="dropDown.selectedCinema"
                :allowEmpty="false"
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                :searchable="true"
                :showLabels="false"
                label="cine_name"
                placeholder="Select Cinema"
                track-by="cine_id"
                @input="onSelectCinema($event)"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  :monday-first="true"
                  type="date"
                  @selected = "onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :monday-first="true"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getVoucherUseageReport('N', 'N', '')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div class="w-100">
            <div class="d-flex justify-content-end align-items-center mb-4">
              <div class="col-lg-6 col-xl-3 align-self-center mb-0">
                <div class="dropdown-curve-container">
                  <!-- <label :class="selectedVoucherName ? 'shift-up' : ''">{{
                    $t("Select Voucher Name")
                  }}</label> -->
                  <multiselect
                    :disabled="isRoleID"
                    :options="voucherList"
                    v-model="selectedVoucher"
                    :searchable="true"
                    label="voucher_title"
                    track-by="voucher_id"
                    placeholder="Select Voucher"
                    :showLabels="false"
                    :multiple="true"
                  >
                  </multiselect>
                </div>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-0">
                <div class="dropdown-curve-container">
                  <!-- <label :class="selectedBookingSource ? 'shift-up' : ''">{{
                    $t("Select Sales Channel")
                  }}</label> -->
                  <multiselect
                    :disabled="isRoleID"
                    v-model="selectedSource"
                    :options="bookingList"
                    :searchable="true"
                    label="bs_source"
                    track-by="booking_source_id"
                    placeholder="Select Sales Channel"
                    :showLabels="false"
                    :multiple="true"
                  >
                  </multiselect>
                </div>
              </div>

              <div class="d-flex align-items-center justify-content-end w-100">
                <div class="mx-2">
                  <div
                    v-if="voucherUseageRecords.length > 0"
                    class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
                  >
                    <div class="mx-1">{{ $t("download") }} as:</div>
                    <!-- s -->

                    <a
                      download
                      target="_blank"
                      title="Download as Excel"
                      @click="getVoucherUseageReport('Y', 'N', '')"
                    >
                      <img
                        class="mx-1"
                        height="25"
                        src="@/assets/img/icons/excel.svg"
                        width="25"
                      />
                    </a>
                    <a
                      download
                      target="_blank"
                      title="Download as Pdf"
                      @click="getVoucherUseageReport('N', 'Y', '')"
                    >
                      <img
                        class="mx-1"
                        height="25"
                        src="@/assets/img/icons/pdf.svg"
                        width="25"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        ref="exportable_table"
        style="overflow-x: scroll; width: auto !important"
      >
        <table border="1" class="swc-report-table swc_table_header">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Voucher Title</th>
            <th>Voucher Code</th>
            <th>Vouchers Redeemed</th>
            <th>Vouchers Expired At</th>
            <th>Transaction Number</th>
            <th>Movie/Fnb Name</th>
            <th>Show Date</th>
            <th>Show Time</th>
            <th>Staff Name</th>
            <th>Operator Name</th>
            <th>No Of Ticket/Fnb</th>
            <th>Seat Type</th>
            <th>Seat Number</th>
            <th>Transaction Amount</th>
            <th>Voucher Amount</th>
            <th>Amount Paid</th>
            <th>Sales Channels</th>
            <th>Voucher Remarks</th>
            <th>BO Remarks</th>
            <th>Customer Email</th>
            <th>Customer Mobile</th>
          </thead>
          <tbody v-if="voucherUseageRecords.length > 0">
            <tr
              v-for="(voucherUseageObj,
              voucherUseageIndex) in voucherUseageRecords"
              :key="voucherUseageIndex"
            >
              <td class="text-left">{{ voucherUseageObj.voucher_name }}</td>
              <td class="text-left">{{ voucherUseageObj.voucher_code }}</td>
              <td class="text-right">1</td>
              <td class="text-right">
                {{ voucherUseageObj.voucher_end_date_time }}
              </td>
              <td class="text-left">
                {{ voucherUseageObj.transaction_no }}
              </td>
              <td class="text-left">{{ voucherUseageObj.movie_item_name }}</td>
              <td class="text-right">{{
                voucherUseageObj.t_show_date || "-"
              }}</td>
              <td class="text-right">{{
                voucherUseageObj.t_show_time || "-"
              }}</td>
              <td class="text-left">{{ voucherUseageObj.voucher_comment }}</td>
              <td class="text-left">{{ voucherUseageObj.operator_name }}</td>
              <td class="text-right">
                {{ voucherUseageObj.ticket_sold }}
              </td>
              <td class="text-left">{{ voucherUseageObj.seat_type || "-" }}</td>
              <td class="text-left">{{ voucherUseageObj.seat_name || "-" }}</td>
              <td class="text-right">
                {{ currFormat(voucherUseageObj.gross_amount_before_offer) }}
              </td>
              <td class="text-right">
                {{ currFormat(voucherUseageObj.discount_price) }}
              </td>
              <td class="text-right">
                {{ currFormat(voucherUseageObj.gross_amount) }}
              </td>
              <td class="text-left">{{ voucherUseageObj.sales_channel }}</td>
              <td class="text-left"
                >{{ voucherUseageObj.remark || "-" }}
              </td>
              <td class="text-left"
                >{{ voucherUseageObj.bo_trx_remarks || "-" }}
              </td>
              <td class="text-left"
                >{{
                  voucherUseageObj.cust_email
                    ? voucherUseageObj.cust_email
                    : voucherUseageObj.guest_email
                    ? voucherUseageObj.guest_email
                    : "-"
                }}
              </td>
              <td class="text-left"
                >{{
                  voucherUseageObj.cust_mobile
                    ? voucherUseageObj.cust_mobile
                    : voucherUseageObj.guest_mobile
                    ? voucherUseageObj.guest_mobile
                    : "-"
                }}
              </td>
            </tr>
            <tr
              v-if="Object.keys(grandTotal).length"
              class="bg-lightgrey font-weight-bold"
            >
              <td class="text-left" colspan="2">Grand Total</td>
              <td class="text-right">
                {{ grandTotal.total_vouchers_redeemed }}
              </td>
              <td class="text-left" colspan="7"></td>

              <td class="text-right">{{ grandTotal.total_tickets }}</td>
              <td class="text-left"></td>
              <td></td>
              <td class="text-right">
                {{ currFormat(grandTotal.total_gross_amount_before_offer) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.total_voucher_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.total_gross_amount) }}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="13">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import NewReportService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        searchVoucher: "",
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        voucherUseageRecords: [],
        excelFilePath: "",
        grandTotal: {},
        selectedVoucherName: null,
        voucherNames: [],
        selectedBookingSource: null,
        bookingSources: [],
        allvoucherName: [],
        allSalesChanalles: [],
        voucherList: [],
        selectedVoucher: [],
        bookingList: [],
        selectedSource: [],
      };
    },

    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
    },
    watch: {
      excelFilePath(value) {
        this.excelFilePath = value;
      },
      toDate(newToDate, oldToDate) {
        if (this.toDate && newToDate) {
          this.getVoucherUseageReport("N", "N", "filter");
        }
      },
    },

    methods: {
      moment,
      onChangeDate(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, {
          sheet: `RawMaterialSupplierWise`,
        });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(
              wb,
              fn ||
                `RawMaterialSupplierWiseCost-${
                  this.dropDown.selectedCinemaName
                }.${type || "xlsx"}`
            );
      },
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.getVoucherUseageReport("N", "N", "filter");
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getVoucherUseageReport(isExcel = "N", isPdf = "N", type = "") {
        if (isExcel == "N" || isPdf == "N" || type == "") {
          this.voucherUseageRecords = [];
        }
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel,
          isPdf,
          type: type || "",
        };

        if (this.selectedVoucher.length > 0) {
          payload.voucher_id = this.selectedVoucher.map(
            (voucher) => voucher.voucher_id
          );
        }
        if (this.selectedSource.length > 0) {
          payload.booking_source_id = this.selectedSource.map(
            (voucher) => voucher.booking_source_id
          );
        }

        NewReportService.GetVoucherUseageReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (type == "filter") {
                this.voucherList = data.Records;
                this.bookingList = data.allBookingData;
                // console.log("this.voucherList", this.voucherList);
              } else {
                this.voucherUseageRecords = [...data.Records];
                console.log("voucherUseageRecords", this.voucherUseageRecords);
                this.grandTotal = { ...data.grandTotal };
                if (isExcel === "Y" && data.excelPath) {
                  window.open(data.excelPath, "_blank");
                }
                if (isPdf === "Y" && data.pdfPath) {
                  window.open(data.pdfPath, "_blank");
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch((error) => {
            console.error("Error fetching report:", error);
            loader.hide();
            this.$toasted.show("An error occurred while fetching the report.");
          });
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }

  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }

  .swc-report-table td {
    white-space: nowrap;
  }

  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }

  .swc_table_header th {
    border: 1px solid black !important;
  }

  .no_border {
    border: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/voucherUseageReport.vue